export class GradientConfig {

  public static config = {
    layout: 'vertical', // vertical, horizontal
    subLayout: '', // horizontal-2
    collapseMenu: true,
    layoutType: 'menu-dark', // menu-dark, menu-light, dark
    headerBackColor: 'header-darkgreen', 
    // header-blue, header-red, header-purple, header-info, header-dark, header-orenge
    // header-green, header-yellow, header-orchidgreen, header-indigogreen, header-darkgreen, header-darkblue
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
    
  }
  
}
